import React from 'react'
import Breadcrumb from '../../../components/breadcrumb/breadcrumb'
import Hero from '../../../components/hero-v2/hero'
import Layout from '../../../components/layouts/layout'
import Helmet from 'react-helmet'
import {
  DocumentosInformativosYFormatos,
  InformeDeCoyunturaCuatrimestral,
  PuedoSaberComoEstaInvertidoMiDinero,
  QueHacePrimaAfpConMiDinero,
  QueSonLosInstrumentosDeInversion
} from '../../../components/aportes-y-fondo/en-que-invierten-mi-dinero'

const EnQueInviertenMiDinero = () => {
  const titlesBreadcrumb = {
    titlesIntermediate: [
      {
        index: 0,
        title: 'Empezando a aportar',
        link: '',
      },
    ],
    titleFinal: '¿En qué invierten mi dinero?',
  }

  return (
    <Layout>
      <Helmet>
        <title>¿En qué Invierten mi Dinero? Aportes y Fondo | Prima AFP</title>
        <meta
          name="title"
          content="¿En qué Invierten mi Dinero? Aportes y Fondo | Prima AFP"
          data-react-helmet="true"
        />
        <meta
          name="description"
          content="Descubre que es lo que hacen las AFPs con tus aportes y en mayor detalle como Prima AFP administra e invierte tu dinero para cuidar tu futuro."
          data-react-helmet="true"
        />
        <link
          rel="canonical"
          href="https://www.prima.com.pe/public-zone/aportes-y-fondo/en-que-invierten-mi-dinero/"
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Inicio",  "item": "https://www.prima.com.pe/public-zone/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Aportes y Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/"
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "¿En qué invierten mi dinero?",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/en-que-invierten-mi-dinero/"
                }
              ]
            }
          `}
        </script>
      </Helmet>

      <Hero
        preTitle="Soy afiliado"
        title="¿En qué invierten mi dinero?"
        image={'aportes-y-fondo/en-que-invierten-mi-dinero/banner-en-que-invierten-mi-dinero-desktop.svg'}
        imageMobile={'aportes-y-fondo/en-que-invierten-mi-dinero/banner-en-que-invierten-mi-dinero-mobile.png'}
        arrowDown={true}
        className={'bg-yellow-1'}
      />

      <Breadcrumb
        type="Comisiones"
        GTMSection="en que invierten mi dinero"
        GTMTitle="¿Qué hace Prima AFP con mi dinero?"
        GTMLink="/aportes-y-fondo/en-que-invierten-mi-dinero/"
        titlesBreadcrumb={titlesBreadcrumb}
      />

      <section className={`tw-pt-8 tw-pt-8@lg bg-white`}>
        <QueHacePrimaAfpConMiDinero />
      </section>

      <section className={`tw-pb-12 tw-pb-12@lg bg-gray-2`}>
        <QueSonLosInstrumentosDeInversion />
      </section>

      <section className={`tw-pt-12 tw-pt-12@lg bg-yellow-1`}>
        <PuedoSaberComoEstaInvertidoMiDinero />
      </section>

      <section className={`tw-pt-12 tw-pt-12@lg bg-gray-2 `}>
        <InformeDeCoyunturaCuatrimestral />
      </section>

      <section className="tw-pt-12 tw-pt-18@lg tw-pb-12 tw-pb-18@lg bg-white">
        <DocumentosInformativosYFormatos />
      </section>
    </Layout>
  )
}

export default EnQueInviertenMiDinero
